export default __webpack_public_path__ + "images/9ed39647f971d480dfc062780d3390b3-fashion.webp";